import { Popover } from '@mui/material'
import React from 'react'

interface FilterReportProps {
  anchorEl: null | HTMLElement
  open: boolean
  handleClose: () => void
  handleDataSelect: () => React.ReactNode
}

const FilterReport = ({
  anchorEl,
  open,
  handleClose,
  handleDataSelect,
}: FilterReportProps) => {
  return (
    <Popover
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      sx={{
        ".MuiPaper-root": {
          padding: "8px 0px",
        },
      }}
      disableScrollLock
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            boxShadow: "0px 0px 8px 0px rgba(28, 28, 28, 0.12)",
            backgroundColor: "rgba(255, 255, 255, 1)",
          },
        },
      }}
      transformOrigin={{
        horizontal: "center",
        vertical: "top",
      }}
      anchorOrigin={{
        horizontal: "center",
        vertical: "bottom",
      }}
    >
      {handleDataSelect()}
    </Popover>
  )
}

export default FilterReport